"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageDetails = exports.Irb = exports.getPackageKey = exports.serializeViewport = void 0;
const types_1 = require("./types");
/**
 * Serialize viewport to "{width}x{height}@{scale}".
 */
const serializeViewport = (vp) => `${vp.width}x${vp.height}@${vp.scale}`;
exports.serializeViewport = serializeViewport;
/**
 * Build the unique key for an IRB package, including viewport and optional cover-page suffix.
 */
const getPackageKey = ({ buildVersion, locale, modality, viewport, isCoverPageIncluded, }) => {
    const vpKey = (0, exports.serializeViewport)(viewport);
    const base = `${buildVersion}-${locale}-${modality}-${vpKey}`;
    return isCoverPageIncluded ? `${base}-cover-page` : base;
};
exports.getPackageKey = getPackageKey;
const pruneUndefinedValues = (obj) => Object.fromEntries(Object.entries(obj).filter(([, value]) => value !== undefined));
class Irb {
    constructor(idObject) {
        const { studyId } = idObject;
        this.id = `study.${studyId}`;
        this.idObject = idObject;
        this.packageDetails = new PackageDetails(this);
    }
    getId() {
        return this.id;
    }
    getIdObject() {
        return this.idObject;
    }
    getMetadata() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.cachedEntry) {
                this.cachedEntry = yield this.getDatabaseEntry();
            }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const _a = this.cachedEntry || {}, { packages } = _a, rest = __rest(_a, ["packages"]);
            return Object.assign({}, rest);
        });
    }
    setMetadata(data) {
        return __awaiter(this, void 0, void 0, function* () {
            delete this.cachedEntry;
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { packages } = data, rest = __rest(data, ["packages"]);
            yield this.updateDatabaseEntry(rest);
        });
    }
    enqueue(queueList, user) {
        return __awaiter(this, void 0, void 0, function* () {
            if (queueList.size === 0) {
                return;
            }
            delete this.cachedEntry;
            const queue = {};
            const enqueuedPackages = {};
            for (const queueItem of queueList) {
                const { buildVersion, locale, modality, viewport, isCoverPageIncluded } = queueItem;
                const packageKey = (0, exports.getPackageKey)(queueItem);
                queue[packageKey] = queueItem;
                enqueuedPackages[packageKey] = {
                    buildVersion,
                    locale,
                    modality,
                    viewport,
                    isCoverPageIncluded,
                    status: types_1.IrbStatus.ENQUEUED,
                    createdAt: new Date(),
                    user,
                };
            }
            yield this.updateDatabaseEntry({ queue, packages: enqueuedPackages });
        });
    }
    getPackage(packageId) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            if (!this.cachedEntry) {
                this.cachedEntry = yield this.getDatabaseEntry();
            }
            const packageKey = (0, exports.getPackageKey)(packageId);
            const pkg = (_b = (_a = this.cachedEntry) === null || _a === void 0 ? void 0 : _a.packages) === null || _b === void 0 ? void 0 : _b[packageKey];
            if (!pkg) {
                return;
            }
            return Object.assign(Object.assign({}, pkg), ((_c = (yield this.packageDetails.get(packageId))) !== null && _c !== void 0 ? _c : {}));
        });
    }
    clearPackage(packageId) {
        return __awaiter(this, void 0, void 0, function* () {
            delete this.cachedEntry;
            const packageKey = (0, exports.getPackageKey)(packageId);
            yield this.updateDatabaseEntry({
                packages: {
                    [packageKey]: null,
                },
            });
            yield this.packageDetails.set(packageId, {});
        });
    }
    setPackage(packageId, arg2) {
        return __awaiter(this, void 0, void 0, function* () {
            delete this.cachedEntry;
            const { buildVersion, locale, modality, viewport, isCoverPageIncluded } = packageId;
            const { status, errorMessage, url, user, createdAt: _ } = arg2, details = __rest(arg2, ["status", "errorMessage", "url", "user", "createdAt"]);
            const packageKey = (0, exports.getPackageKey)(packageId);
            yield this.updateDatabaseEntry({
                packages: {
                    [packageKey]: pruneUndefinedValues({
                        buildVersion,
                        locale,
                        modality,
                        viewport,
                        isCoverPageIncluded,
                        status,
                        errorMessage,
                        url,
                        user,
                        createdAt: new Date(),
                    }),
                },
            });
            if (details && Object.keys(details).length > 0) {
                yield this.packageDetails.update(packageId, details);
            }
        });
    }
    getDatabaseEntry() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('getDatabaseEntry not implemented');
        });
    }
    setDatabaseEntry(entry) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`setDatabaseEntry not implemented, ${entry}`);
        });
    }
    updateDatabaseEntry(entry) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`updateDatabaseEntry not implemented, ${entry}`);
        });
    }
}
exports.Irb = Irb;
class PackageDetails {
    constructor(irb) {
        this.irb = irb;
        this.cachedEntry = new Map();
    }
    get(packageId) {
        return __awaiter(this, void 0, void 0, function* () {
            const key = (0, exports.getPackageKey)(packageId);
            if (!this.cachedEntry.has(key)) {
                const entry = yield this.getDatabaseEntry(key);
                if (entry) {
                    this.cachedEntry.set(key, entry);
                }
            }
            return this.cachedEntry.get(key);
        });
    }
    set(packageId, entry) {
        return __awaiter(this, void 0, void 0, function* () {
            const key = (0, exports.getPackageKey)(packageId);
            this.cachedEntry.set(key, entry);
            yield this.setDatabaseEntry(key, entry);
        });
    }
    update(packageId, entry) {
        return __awaiter(this, void 0, void 0, function* () {
            const key = (0, exports.getPackageKey)(packageId);
            this.cachedEntry.delete(key);
            yield this.updateDatabaseEntry(key, entry);
        });
    }
    getDatabaseEntry(packageId) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`getDatabaseEntry not implemented, ${packageId}`);
        });
    }
    setDatabaseEntry(packageId, entry) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`setDatabaseEntry not implemented, ${packageId} ${entry}`);
        });
    }
    updateDatabaseEntry(packageId, entry) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`updateDatabaseEntry not implemented, ${packageId} ${entry}`);
        });
    }
}
exports.PackageDetails = PackageDetails;
//# sourceMappingURL=irb.js.map